import './App.css';
import AgenciesForm from '@revenatium/vibranium-agencies/dist/components/AgenciesForm'
import toast, { Toaster } from 'react-hot-toast';

function App({ parent }) {
   const onComplete = () => {
      const returnUrl = parent?.dataset?.return_url || null;
      if (returnUrl) {
         document.location.href = returnUrl;
      }
   };
   const onError = (error) => {
      toast.error(error);
   };

   return (
      <>
         <AgenciesForm isPublic onComplete={onComplete} onError={onError} account={'ixtul'} />
         <Toaster position="bottom-right" />
      </>
   );
}

export default App;
